
import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum";
import { PeriodPartSelectionEnum } from "../enums/periodPartSelectionEnum";
import { TimeIntervalEnum } from "../enums/timeIntervalEnum";

import * as appsettings from "../appsettings";
import * as main from "../main";
import * as moment from "moment";
import * as timeinterval from "../timeinterval";
import * as viewmode from "../viewmode";
import * as grid from "../grid";

let dateTimeErrorMessageLabel = "";

/*
* Show / Hide Period Selector
**/
function setVisibilityPeriodSelector(): void {
    const timeinterval_value = parseInt($("#TimeInterval").data("kendoDropDownList").value());

    if (timeinterval_value == TimeIntervalEnum.AskedPeriod) {
        $("#periodSelector").show();
    } else {
        $("#periodSelector").hide();
    }
}

/**
* Initialize
*/
export function initialize(dateTimeErrorMessage: string): void {
    dateTimeErrorMessageLabel = dateTimeErrorMessage;

    main.setHideDiv("errorMessage", false);
    $("#ReportMessageSearchButtonLoader").hide();
    $("#ReportMessageExportButtonLoader").hide();

    setVisibilityPeriodSelector();
    this.searchAction(null);
}

/**
* setReallyAvailable
*/
export function setReallyAvailable(id: number, element: HTMLInputElement): void {

    // Do request
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("ReportMessage/SetReallyAvailable"),
        data: {
            msgInlogUserId: id,
            value: element.checked,
        },
        success: function () {

        }
    });

}

/**
* onChange for TimeInterval (show / hide periodSelector)
*/
export function onChangeTimeInterval(): void {
    setVisibilityPeriodSelector();
}

/**
* Action export (will download excel document according to the selected period)
*/
export function exportAction(e: kendo.ui.ButtonClickEvent): void {
    // Stop the browser from following
    e.preventDefault();

    main.setHideDiv("errorMessage", false);

    // Show the waiting indicator
    $("#ReportMessageExportButtonLoader").show();

    // Get preference / options selected
    const selectedGroupId = Number($("#GroupId").data("kendoDropDownList").value());
    const selectedInterval = Number($("#TimeInterval").data("kendoDropDownList").value());

    // Get selection period
    let from: string = "";
    let fromDt = timeinterval.getBeginPeriodSelection(selectedInterval, "From");
    if (fromDt != null) {
        from = fromDt.toUTCString();
    }

    let to: string = "";
    let toDt = timeinterval.getEndPeriodSelection(selectedInterval, "To");
    if (toDt != null) {
        to = toDt.toUTCString();
    }

    if (from != "" && to != "") {
        // Download File
        $.fileDownload(appsettings.getLocalUrl('ReportMessage/Export?groupId=' + selectedGroupId + "&from=" + from + "&to=" + to))
            .done(function () { $("#ReportMessageExportButtonLoader").hide(); })
            .fail(function () { $("#ReportMessageExportButtonLoader").hide(); });
    }
    else {
        // Hide Indicator
        $("#ReportMessageExportButtonLoader").hide();

        // make a message
        main.setHideDiv("errorMessage", true);

        var lblError = $("#errorMessageLabel");
        if (lblError != null && lblError != undefined) {
            lblError.text(dateTimeErrorMessageLabel);
        }
    }
}

/**
* Action search (will display certain bar charts according to the selected period)
*/
export function searchAction(): void {
    // Indicator
    $("#ReportMessageSearchButtonLoader").show();

    main.setHideDiv("errorMessage", false);

    // get preference / options selected
    const selectedGroupId = parseInt($("#GroupId").data("kendoDropDownList").value());
    const selectedInterval = parseInt($("#TimeInterval").data("kendoDropDownList").value());
    const selectedPeriod = parseInt($("#PeriodPartSelection").data("kendoDropDownList").value());

    // Get selection period
    let From: string = "";
    let FromDt = timeinterval.getBeginPeriodSelection(selectedInterval, "From");
    if (FromDt != null) {
        From = moment(FromDt.toUTCString()).format("YYYY-MM-DD[T]HH:mm:ss");
    }

    let To: string = "";
    let ToDt = timeinterval.getEndPeriodSelection(selectedInterval, "To");
    if (ToDt != null) {
        To = moment(ToDt.toUTCString()).format("YYYY-MM-DD[T]HH:mm:ss");
    }

    if (From != "" && To != "") {
        // Do request
        $.ajax({
            type: "GET",
            url: appsettings.getUrl("ReportMessage/Search"),
            data: {
                GroupId: selectedGroupId,
                From: From,
                To: To,
                WorkingDay: selectedPeriod == PeriodPartSelectionEnum.FullPeriod ? null : selectedPeriod
            },
            success: function (responseData: string) {
                // Get response
                $("#searchResult").html(responseData);

                // Hide Indicator
                $("#ReportMessageSearchButtonLoader").hide();
            }
        });
    }
    else {
        // Hide Indicator
        $("#ReportMessageSearchButtonLoader").hide();

        // make a message
        main.setHideDiv("errorMessage", true);

        const lblError = $("#errorMessageLabel");
        if (lblError != null && lblError != undefined) {
            lblError.text(dateTimeErrorMessageLabel);
        }
    }
}


export function showMessageItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // 
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as GridMessageItemVM;

    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // Do request
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("ReportMessage/MessageDetails"),
        data: {
            messageInLogId: dataItem.MsgInLogID,
            incidentLogID: dataItem.IncidentLogID
        },
        success: function (responseData: string) {
            // Get response
            $("#selectedMessage").html(responseData);
        }
    });
}

export function editMessageItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // 
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as GridMessageItemVM;

    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // Do request
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("ReportMessage/MessageDetails"),
        data: {
            messageInLogId: dataItem.MsgInLogID,
            incidentLogID: dataItem.IncidentLogID
        },
        success: function (responseData: string) {
            // Get response
            $("#selectedMessage").html(responseData);
        }
    });
}


/**
* start / from 
*/
export function fromChange(): void {
    const start = $("#From").data("kendoDateTimePicker");
    const end = $("#To").data("kendoDateTimePicker");
    let startDate = start.value();
    let endDate = end.value();

    if (startDate) {
        startDate = new Date(startDate);
        startDate.setDate(startDate.getDate());
        end.min(startDate);
    } else if (endDate) {
        start.max(new Date(endDate));
    } else {
        endDate = new Date();
        start.max(endDate);
        end.min(endDate);
    }
}

/**
* end / to
*/
export function toChange(): void {
    const start = $("#From").data("kendoDateTimePicker");
    const end = $("#To").data("kendoDateTimePicker");
    let endDate = end.value();
    let startDate = start.value();

    if (endDate) {
        endDate = new Date(endDate);
        endDate.setDate(endDate.getDate());
        start.max(endDate);
    } else if (startDate) {
        end.min(new Date(startDate));
    } else {
        endDate = new Date();
        start.max(endDate);
        end.min(endDate);
    }
}

/*
 * 
 */
export function initialMessageDetails(dtgTitleLabel: string, inhoudLabel: string, gridData: IncidentKladblokNotitieVM[], showProposalServiceFunction: boolean, showIncident: boolean): void {

    $("#RIncidentKladblokregelsGrid").kendoGrid({
        dataSource: {
            data: gridData,
            pageSize: 10,
        },
        height: 500,
        pageable: true,
        columns: [
            { field: "DTGLocalStr", title: dtgTitleLabel },
            { field: "Inhoud", title: inhoudLabel }
        ],
    });

    const kendoGrid = $("#RIncidentKladblokregelsGrid").data("kendoGrid");
    kendoGrid.autoFitColumn(0);

    if (showProposalServiceFunction) {
        $(".RProposalServiceFunction").parent().show();
    } else {
        $(".RProposalServiceFunction").parent().hide();
    }

    if (showIncident) {
        $(".PIncident").parent().show();
    } else {
        $(".PIncident").parent().hide();
    }

    if (showIncident) {
        $(".RIncidentKladblokregels").parent().show();
    } else {
        $(".RIncidentKladblokregels").parent().hide();
    }

    grid.loadGridOptions("ReportUserResponseGrid");
}
